import { useEffect, useState, useRef } from "react";
import MapConfig from "../utils/map-config.json";
import L from "leaflet";

const BasemapControl = (props) => {
  const map = props.map;
  const tileLayerRef = useRef(null);
  const [selectedBasemap, setSelectedBasemap] = useState(MapConfig.Basemaps[0].id);
  const { setAttribution } = props;

  useEffect(() => {
    const layerConfig = MapConfig.Basemaps.find((l) => l.id === selectedBasemap);
    if (!layerConfig || !map) return;

    if (tileLayerRef.current) {
      map.removeLayer(tileLayerRef.current);
    }

    const newTileLayer = L.tileLayer(layerConfig.url, {
      attribution: layerConfig.attribution,
      zIndex: 0
    });
    newTileLayer.addTo(map);
    newTileLayer.bringToBack();
    tileLayerRef.current = newTileLayer;
    setAttribution(layerConfig.attribution);
  }, [selectedBasemap, setAttribution, map]);

  const changeBasemap = (id) => {
    setSelectedBasemap(id);
  }

  return (
    <>
      {
        props.active &&
        <div className="basemap-container">
          {MapConfig.Basemaps.map((layer) => (
            <div
              key={layer.id}
              className={"basemap-item" + (selectedBasemap === layer.id ? " selected" : "")}
              onClick={() => changeBasemap(layer.id)}
              title={layer.name}
            >
              <img src={layer.thumbnail} alt={layer.name} />
              <div className="basemap-name">{layer.name}</div>
            </div>
          ))}
        </div>
      }
    </>
  );
}

export default BasemapControl;
